import { lazy } from "react";

const MembershipOffersPage = lazy(() => import("./main"));
const UpdateMembershipOffersPage = lazy(() => import("./update"));

export { MembershipOffersPage, UpdateMembershipOffersPage };
